import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateRepositorySettings } from "./api";
import type {
  RepositorySettingsResponse,
  UpdateRepositorySettingsRequest,
} from "./api";

interface UpdateVars {
  readonly repoFullName: string;
  readonly body: UpdateRepositorySettingsRequest;
}

// PUT настроек репо. На успех инвалидируем запрос этого репозитория —
// форма перерисуется с сохранёнными значениями. Паттерн
// `useSetRepoTemplate`.
export function useUpdateRepositorySettings(): ReturnType<
  typeof useMutation<RepositorySettingsResponse, Error, UpdateVars>
> {
  const queryClient = useQueryClient();
  return useMutation<RepositorySettingsResponse, Error, UpdateVars>({
    mutationFn: (vars) =>
      updateRepositorySettings(vars.repoFullName, vars.body),
    onSuccess: (_data, vars) => {
      void queryClient.invalidateQueries({
        queryKey: ["repositorySettings", vars.repoFullName],
      });
    },
  });
}
